import React from 'react';
import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";
import dayjs from 'dayjs';
import TicketDetails from '../../../../components/company_operations/ticket-search/Details';

//  I N T E R F A C E S 
export interface TicketDetail {
    ActionCollection: ActionCollection[];
    Address: string;
    City: string;
    Excavator: string;
    GeoLat: string;
    GeoLong: string;
    ImportDatets: number;
    NoticeID: string;
    PictureCollection: PictureCollection[];
    State: string;  // code
    TicketFullText: string;
    TicketID: number;
    TicketNumber: string;
    TicketRevision: string;
    TicketType: string;
}
export interface ActionCollection {
    Action: string;
    ActionDatets: number;
    UtilityID: number;
}
export interface PictureCollection {
    AttachedToID: number;
    AttachedToTypeID: number;
    AttachmentID: number;
    AttachmentTypeID: number;
    Comments: string | undefined;
    ImageFileStoreLocation: number;
    ImageFullPath: string;
    ImmageFullUrl: string;
    Name: string;
    RelativePath: string;
}

//  A P I   C A L L S
export const getTicketDetails = async (ticketId: number) => {
    const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/TicketQuery/GetTicketDetail?ticketId=${ticketId}`, AxiosConfig.configValue('min'));
    
    if (response.status != 200) {
        return { success: false, response: response.statusText }
    }

    const ticketDetail: TicketDetail = {
        ActionCollection: response.data.ActionCollection,
        Address: response.data.Address,
        City: response.data.City,
        Excavator: response.data.Excavator,
        GeoLat: response.data.GeoLat,
        GeoLong: response.data.GeoLong,
        ImportDatets: response.data.ImportDatets,
        NoticeID: response.data.NoticeID,
        PictureCollection: response.data.PictureCollection,
        State: response.data.State,
        TicketFullText: response.data.TicketFullText,
        TicketID: response.data.TicketID,
        TicketNumber: response.data.TicketNumber,
        TicketRevision: response.data.TicketRevision,
        TicketType: response.data.TicketType
    }
    return { success: true, response: ticketDetail }
}

//  F U N C T I O N S
export const initializeTimeAdminTicketDetail = async (ticketId: number) => {
    const ticketDetailResponse = await getTicketDetails(ticketId);
    if (!ticketDetailResponse.success || typeof(ticketDetailResponse.response) == 'string') {
        return { success: false, response: ticketDetailResponse.response }
    }
    const detail: TicketDetail = ticketDetailResponse.response;
    return { success: true, response: detail };
}

export const renderTicketDetail = (details: TicketDetail, userId: number) => {
    return (
        <div>
            <TicketDetails
                handleClose={() => { }}
                details={details}
                toggleVertical={() => { }}
                isVertical={false}
                userId={userId}
            />
        </div>
    )
}